export const COL_BACKGROUNDS = [
  '#1C1C1E',
  'linear-gradient(180deg, rgba(232, 233, 233, 0.4) 0%, rgba(253, 253, 251, 0.4) 37%, rgba(148, 151, 157, 0.4) 75%, rgba(197, 199, 204, 0.4) 100%)',
  'linear-gradient(180deg, rgba(251, 242, 174, 0.6) 0%, rgba(162, 104, 19, 0.6) 50%, rgba(217, 170, 86, 0.6) 100%)',
] as const;
